import { ReactNode } from "react"
import { ConfigProvider } from "antd"

type Props = {
	children: ReactNode
}

export const MenuProvider = ({ children }: Props) => {
	return (
		<ConfigProvider
			theme={{
				components: {
					Menu: {
						itemBg: "transparent",
						subMenuItemBg: "transparent",
						itemSelectedBg: "var(--clr-lightBlue)",
						itemBorderRadius: 10,
						subMenuItemBorderRadius: 10,
					},
				},
			}}
			menu={{
				style: {
					borderInlineEnd: "none",
				},
			}}
		>
			{children}
		</ConfigProvider>
	)
}
